import {
  WorkOrder,
  updateState,
} from "@/services/backend/htz/work-order/types/work-order";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/shared/components/ui/dialog";
import { Button } from "@/shared/components/ui/button";
import t from "@/lang/lang";
import { CommonDialogFooter } from "@/shared/components/dialog/dialog-common";
import { useHtzWorkOrderPutMutation } from "@/services/backend/htz/work-order/api/work-order-api";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { FulfillmentState } from "@/services/backend/relationships/types/fulfillment";

export function CancelWorkOrderDialog({ workOrder }: { workOrder: WorkOrder }) {
  const [put, { isLoading, error }] = useHtzWorkOrderPutMutation();

  const doForward = () => {
    if (isLoading) return;

    put(updateState(workOrder, FulfillmentState.Cancelled));
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button variant="secondary">{t("Stornieren")}</Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("Arbeitsschein stornieren?")}</DialogTitle>
          <DialogDescription>
            {t(
              "Der Arbeitsschein wird als storniert markiert. Er wird dann nicht mehr in der Planung oder Ausführung angezeigt.",
            )}
          </DialogDescription>
        </DialogHeader>
        <RTKQueryErrorAlert error={error} ignoreValidationError={false} />
        <CommonDialogFooter isLoading={isLoading} onClickAction={doForward} />
      </DialogContent>
    </Dialog>
  );
}
